import { FILTER_TYPE_CHECKBOX, ITEM_COUNT_SMALL_WIDTH, ITEM_COUNT_FULL_WIDTH, FILTER_NAME_IS_NOT_VALID, FILTER_NAME_IS_DELETED, FILTER_GROUP_NAME_STATUS, LOCALE_EN, LOCALE_RU } from "../constant";
import { PROPERTIES_URL, getFetchRequest } from "../store/requests";
import { propertyNamesService } from "./propertyNamesService";
import { isSmallWebScreen, sortByDate } from "../components/helper";
import {errorCallback, makeUrl} from "../util";
import i18n from '../i18nService';

const createListOfFilters = (i18nInstance = i18n) => {
    return [ 
        {
            filterTitle: i18nInstance.t('app.page.property.filters.number'),
            filterName: 'number',
            filterType: FILTER_TYPE_CHECKBOX,
            variants: [],
            value: false,
            filterGroupName: 'propertyType',
        },
        {
            filterTitle: i18nInstance.t('app.page.property.filters.select'),
            filterName: 'select',
            filterType: FILTER_TYPE_CHECKBOX,
            variants: [],
            value: false,
            filterGroupName: 'propertyType',
        },
        {
            filterTitle: i18nInstance.t('app.page.property.filters.boolean'),
            filterName: 'boolean',
            filterType: FILTER_TYPE_CHECKBOX,
            variants: [],
            value: false,
            filterGroupName: 'propertyType',
        },
        {
            filterTitle: i18nInstance.t('app.page.property.filters.string'),
            filterName: 'string',
            filterType: FILTER_TYPE_CHECKBOX,
            variants: [],
            value: false,
            filterGroupName: 'propertyType',
        },
        {
            filterTitle: i18nInstance.t('app.page.property.filters.macronutrients'),
            filterName: 'macronutrient',
            filterType: FILTER_TYPE_CHECKBOX,
            variants: [],
            value: false,
            filterGroupName: 'categoryName',
        },
        {
            filterTitle: i18nInstance.t('app.page.property.filters.micronutrients'),
            filterName: 'micronutrient',
            filterType: FILTER_TYPE_CHECKBOX,
            variants: [],
            value: false,
            filterGroupName: 'categoryName',
        },
        {
            filterTitle: i18nInstance.t('app.page.property.filters.physical'),
            filterName: 'physical',
            filterType: FILTER_TYPE_CHECKBOX,
            variants: [],
            value: false,
            filterGroupName: 'categoryName',
        },
        {
            filterTitle: i18nInstance.t('app.page.property.filters.notVitamin'),
            filterName: 'notVitamin',
            filterType: FILTER_TYPE_CHECKBOX,
            variants: [],
            value: false,
            filterGroupName: 'vitamin',
        },
        {
            filterTitle: i18nInstance.t('app.page.property.filters.fatSoluble'),
            filterName: 'fatSoluble',
            filterType: FILTER_TYPE_CHECKBOX,
            variants: [],
            value: false,
            filterGroupName: 'vitamin',
        },
        {
            filterTitle: i18nInstance.t('app.page.property.filters.waterSoluble'),
            filterName: 'waterSoluble',
            filterType: FILTER_TYPE_CHECKBOX,
            variants: [],
            value: false,
            filterGroupName: 'vitamin',
        },
        {
            filterTitle: i18nInstance.t('product.scheme.filter.isDeleted'),
            filterName: 'isDeleted',
            filterType: FILTER_TYPE_CHECKBOX,
            variants: [],
            value: false,
            filterGroupName: FILTER_GROUP_NAME_STATUS,
        },
        {
            filterTitle: i18nInstance.t('product.scheme.filter.isNotValid'),
            filterName: 'isNotValid',
            filterType: FILTER_TYPE_CHECKBOX,
            variants: [],
            value: false,
            filterGroupName: FILTER_GROUP_NAME_STATUS,
        },
    ];
};

const createQueryParams = (queryParams, showDeletedProperties, isNotValid) => {
    return queryParams ? 
        queryParams
        : 
        `?${showDeletedProperties ? 'withDeleted=true&' : ''}${isNotValid ? 'valid=false&' : ''}${showDeletedProperties || isNotValid ? 'withStatus=true' : ''}`;
};

const filterBySearchValue = (filteredList, searchValue, i18nInstance = i18n) => {
    const query = searchValue.toLowerCase();
    return filteredList.filter((it) => {
        const ruName = propertyNamesService.getLocalization(LOCALE_RU, it, true, i18nInstance).toLowerCase();
        const enName = propertyNamesService.getLocalization(LOCALE_EN, it, true, i18nInstance).toLowerCase();
        return ruName.includes(query) || enName.includes(query) || it.propertyName.toLowerCase().includes(query);
    });
};

export const propertiesStorage = {
    propertiesList: [],
    filtersList: [],
    searchValue: '',
    possibleFilters: [],
    offset: 8,
    filter: '',
    page: 1,
    maxPages: 1,
    observersList: [],
    showDeletedProperties: false,
    showIsNotValid: false,
    loadItems(callback, width, queryParams) {
        try {
            getFetchRequest(makeUrl([PROPERTIES_URL, createQueryParams(queryParams, this.showDeletedProperties, this.showIsNotValid)]), (response) => {
                this.propertiesList = response.sort(sortByDate);
                this.offset = isSmallWebScreen(width) ? ITEM_COUNT_SMALL_WIDTH : ITEM_COUNT_FULL_WIDTH;
                this.reloadPagesNumber();
                callback && callback();
                this.notifyFiltersChangingObservers();
            }, errorCallback);
        } catch(err) {
            console.log(err);
        }
    },

    cleanStorage() {
        this.propertiesList = [];
    },

    getItems(loadAllData) {
        let filteredList = [...this.propertiesList];
        if(this.searchValue) {
            filteredList = filterBySearchValue(filteredList, this.searchValue);
        }
        if(this.filtersList.length) {
            filteredList = filteredList.filter(it => this.filtersList.findIndex(filter => Object.values(it).includes(filter.filterName) || 
                filter.filterGroupName === FILTER_GROUP_NAME_STATUS) >= 0);
        }
        if(this.showDeletedProperties) {
            filteredList = filteredList.filter(it => it.isDeleted);
        }
        return loadAllData ? filteredList : filteredList.slice((this.page - 1) * this.offset, this.page * this.offset);
    },

    getMaxCount() {
        return this.maxPages;
    },

    getCurrentPage() {
        return this.page;
    },

    setPageNumber(value) {
        this.page = value;
        this.notifyFiltersChangingObservers();
    },

    setInitialFilters(searchParams, callback) {
        const filtersList = [];
        searchParams.forEach((value, key) => {
            const currentFilter = this.possibleFilters.find(it => it.filterName === key);
            if(currentFilter.filterType === FILTER_TYPE_CHECKBOX && value === 'true') {
                currentFilter.value = value;
                filtersList.push(currentFilter);
            }
            if(currentFilter.filterName === FILTER_NAME_IS_DELETED && value === 'true') {
                this.changeDeletedItemsView(true);
            }
            if(currentFilter.filterName === FILTER_NAME_IS_NOT_VALID && value === 'true') {
                this.changeValidItemsView(true);
            }
        });
        this.filtersList = filtersList;
        callback && callback();
    },
    getPossibleFilters() {
        this.possibleFilters = createListOfFilters(i18n);
        return this.possibleFilters;
    },
    getCurrentFilters() {
        return this.filtersList;
    },
    getAnyFiltersByGroup(groupName) {
        return this.possibleFilters.find((it) => it.filterGroupName === groupName);
    },
    getCurrentFiltersByGroup(groupName) {
        return this.possibleFilters.filter(it => it.filterGroupName === groupName);
    },
    getFilter(filterName) {
        return this.possibleFilters.find(it => it.filterName === filterName);
    },
    setSearchString(searchStringValue) {
        this.searchValue = searchStringValue;
        this.reloadPagesNumber();
        this.notifyFiltersChangingObservers();
    },
    getSearchString() {
        return this.searchValue;
    },
    setCheckedFilterValue(filterName, selectedKeys) {
        const currentFilter = this.filtersList.find(it => it.filterName === filterName);
        if(currentFilter) {
            currentFilter.value = selectedKeys;
        } else {
            const possibleFilter = this.possibleFilters.find(it => it.filterName === filterName);
            possibleFilter.value = selectedKeys;
            this.filtersList.push(possibleFilter);
        }
        this.filtersList = this.filtersList.filter(it => 
            it.filterType !== FILTER_TYPE_CHECKBOX || (it.filterType === FILTER_TYPE_CHECKBOX && it.value == true));
        this.page = 1;
    },
    setNumberFilterValue(filterName, filterKey, filterValue) {
        this.possibleFilters.forEach(it => it.filterName === filterName ? it[filterKey] = filterValue : null);
    },
    cleanFilterValues() {
        this.filtersList = [];
        this.showDeletedProperties = false;
        this.showIsNotValid = false;
        this.possibleFilters.forEach((it, index) => {
            if(it.filterType === FILTER_TYPE_CHECKBOX) {
                this.possibleFilters[index].value = false;
            }
        });
        this.loadItems();
    },
    registerFiltersChangingObserver(observer) {
        this.observersList.push(observer);
    },
    unRegisterFiltersChangingObserver(observer) {
        this.observersList = this.observersList.filter(observerItem => observerItem !== observer);
    },
    notifyFiltersChangingObservers() {
        this.observersList.forEach(observer => observer());
    },

    changeDeletedItemsView(deletedIsVisible) {
        this.showDeletedProperties = deletedIsVisible;
        this.loadItems();
    },

    changeValidItemsView(isValid) {
        this.showIsNotValid = isValid;
        this.loadItems();
    },
    
    getById(itemId) {
        return this.propertiesList.find(it => it.id === itemId);
    },
    reloadPagesNumber() {
        let filteredList = [...this.propertiesList];
        if(this.searchValue) {
            filteredList = filterBySearchValue(filteredList, this.searchValue);
        }
        if(this.filtersList.length) {
            filteredList = filteredList.filter(it => this.filtersList.findIndex(filter => Object.values(it).includes(filter.filterName) || 
                filter.filterGroupName === FILTER_GROUP_NAME_STATUS) >= 0);
        }
        if(this.showDeletedProperties) {
            filteredList = filteredList.filter(it => it.isDeleted);
        }
        this.maxPages = Math.ceil(filteredList.length / this.offset);
    },
};
